module.exports = __webpack_public_path__ + "assets/grey.32cc551d.svg";